import {fromJS, Map} from 'immutable';
import type {Response} from 'superagent';

import notifier from '@albert-io/notifier';

export function handleMandarkErrorResponse(error: Error, errorResponse: Response) {
  if (!errorResponse || !errorResponse.body) {
    logger.debug(
      'An error was encountered without a response from Mandark.\n %j\n %j',
      error,
      errorResponse
    );
    return;
  }
  try {
    /**
     * In an effort to reduce sampling and noise in our monitoring tools we only send error responses from the
     * API if they are not a 4xx response.
     */
    if (
      (errorResponse.status < 400 || errorResponse.status >= 500) &&
      Object.prototype.hasOwnProperty.call(errorResponse.body, 'errors')
    ) {
      const processedErrors = fromJS(errorResponse.body)
        .get('errors')
        .map((err) =>
          Map({
            code: err.get('code'),
            detail: err.get('detail'),
            status: err.get('status'),
            title: err.get('title'),
            traceId: err.getIn(['meta', 'trace_id']),
            requestId: err.get('id')
          })
        );
      const processedError = !processedErrors.isEmpty() ? processedErrors.first().toJS() : {};
      notifier.notify(error, {
        message: 'Mandark API error response',
        tags: 'mandark',
        context: {
          ...processedError,
          name: 'Mandark Error Response',
          errors: processedErrors.toJS()
        }
      });
    }
    logger.error('Mandark Error Response: %j', error);
  } catch (e) {
    logger.debug('An error was encountered while trying to handle a Mandark error response. %j', e);
  }
}
